var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvatarBgGradient = function SvgAvatarBgGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.248 50.7c-4.431-16.537 5.383-33.535 21.92-37.967L63.3 2.248c16.537-4.431 33.535 5.383 37.967 21.92L111.752 63.3c4.431 16.537-5.383 33.535-21.92 37.967L50.7 111.752c-16.537 4.431-33.535-5.383-37.967-21.92L2.248 50.7Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 121,
    y1: 70.333,
    x2: -7,
    y2: 70.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DD6"
  })))));
};

export { SvgAvatarBgGradient as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE0IiBoZWlnaHQ9IjExNCIgdmlld0JveD0iMCAwIDExNCAxMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjI0ODE0IDUwLjcwMDRDLTIuMTgzMDUgMzQuMTYzIDcuNjMxIDE3LjE2NDUgMjQuMTY4NSAxMi43MzMzTDYzLjI5OTYgMi4yNDgxNEM3OS44MzcgLTIuMTgzMDUgOTYuODM1NSA3LjYzMSAxMDEuMjY3IDI0LjE2ODVMMTExLjc1MiA2My4yOTk2QzExNi4xODMgNzkuODM3IDEwNi4zNjkgOTYuODM1NSA4OS44MzE2IDEwMS4yNjdMNTAuNzAwNCAxMTEuNzUyQzM0LjE2MyAxMTYuMTgzIDE3LjE2NDUgMTA2LjM2OSAxMi43MzMzIDg5LjgzMTZMMi4yNDgxNCA1MC43MDA0WiIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXIpIiBzdHJva2Utd2lkdGg9IjIiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjEyMSIgeTE9IjcwLjMzMzQiIHgyPSItNyIgeTI9IjcwLjMzMzQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0Y0NjczNyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5NDVERDYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";